import { Image, Modal, message } from "antd";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { FiEdit, FiTrash } from "react-icons/fi";
import { useToggle } from "react-use";
import RequiredExperienceModal from "./RequiredExperienceModal";

const RequiredFormExperience = (props) => {
  const { experiences, candidateId, setEnable } = props;
  const [messageApi, contextHolder] = message.useMessage();
  const [isAddExperienceModalOpen, toggleAddExperienceModal] = useToggle(false);
  const [currentEditingExperience, setCurrentEditingExperience] = useState();
  const [editIndex, setEditIndex] = useState(null);

  useEffect(() => {
    if (!isAddExperienceModalOpen) {
      setCurrentEditingExperience({});
      setEditIndex(null);
    }
  }, [isAddExperienceModalOpen]);

  console.log(experiences, "experiencesexperiences");
  return (
    <div>
      <div className="border rounded-md p-spacing3 w-2/3">
        <RequiredExperienceModal
          isEditForm={!isEmpty(currentEditingExperience)}
          close={toggleAddExperienceModal}
          experiences={experiences}
          details={currentEditingExperience}
          editIndex={editIndex}
          candidateId={candidateId}
          setEnable={setEnable}
        />
      </div>
      {/* -----------------------  Modal for Add Experience starts ----------------------- */}
      {isAddExperienceModalOpen && (
        <Modal
          className="addExperienceModal"
          width={700}
          open={isAddExperienceModalOpen}
          title={"Add Experience"}
          onCancel={toggleAddExperienceModal}
          footer={null}
          destroyOnClose
        >
          <RequiredExperienceModal
            isEditForm={!isEmpty(currentEditingExperience)}
            close={toggleAddExperienceModal}
            experiences={experiences}
            details={currentEditingExperience}
            editIndex={editIndex}
            candidateId={candidateId}
            setEnable={setEnable}
          />
        </Modal>
      )}
    </div>
  );
};

export default RequiredFormExperience;
